import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import actions from '../../actions';
import AjaxAction from '../../actions/AjaxAction';
import {Row, Button, Modal, Tabs, message, Icon, Empty, List, Avatar, Comment, Badge, Popconfirm, Input} from 'antd';

import Info from '../Detail/Info';
import UserPhoto from '../Common/UserPhoto';
import Right from '../Detail/RightDetail';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {realGalleryPath} from '../../util/index';

import './index.scss';

class Index extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentGroup:null,
            messages:{},
            unread:{},
            search:'',
            groupStatus:{},
            isKickOut:false
        };
    }

    onConnNotify = (resp)=>{
        var info;
        var webim = window.webim;
        console.log(resp);
        switch (resp.ErrorCode) {
            case webim.CONNECTION_STATUS.ON:
                webim.Log.warn('建立连接成功: ' + resp.ErrorInfo);
                break;
            case webim.CONNECTION_STATUS.OFF:
                info = '连接已断开，无法收到新消息，请检查下您的网络是否正常: ' + resp.ErrorInfo;
                webim.Log.warn(info);
                break;
            case webim.CONNECTION_STATUS.RECONNECT:
                info = '连接状态恢复正常: ' + resp.ErrorInfo;
                webim.Log.warn(info);
                break;
            default:
                webim.Log.error('未知连接状态: =' + resp.ErrorInfo);
                break;
        }
    }

    onMsgNotify = (newMsgList)=>{
        console.log('msgnotify', newMsgList);

        let {unread} = this.state;
        let {dispatch} = this.props;

        newMsgList.forEach(msg=>{
            try {
                var groupid = msg.to;
                if(!unread[groupid]) {
                    unread[groupid] = [];
                }
                var result = this.formatItem(msg);
                result.forEach(it=>{
                    unread[groupid].push(it);
                });

                let {onNewMsg} = this.props;
                if(onNewMsg) {
                    onNewMsg();
                }

                dispatch(AjaxAction.imGroupUpdate(groupid, {
                  lastMessageTime:Math.round(Date.now() / 1000)
                }));
            }catch(e) {}
        });

        this.setState({
            unread
        });
    }

    onGroupSystemNoticeReceived = function(event) {
      const type = event.data.type; // 群系统通知的类型，详见 群系统通知类型常量及含义
      const message = event.data.message; // 群系统通知的消息实例，详见 Message
      console.log(message.payload); // 消息内容. 群系统通知 payload 结构描述
    };


    componentWillMount() {
        let {dispatch} = this.props;
        if(1 || !window.dev) {
            dispatch(AjaxAction.imLogin()).then(res=>{
                // init im
                let {data} = res;

                let createOption = {
                  SDKAppID:data.appid,
                };

                if(!window.TIM) {
                  return;
                }
                window.tim = window.TIM.create(createOption);

                window.tim.login({
                  userID: data.userid,
                  userSig: data.sign
                }).then(res=>{
                  if(res && res.code === 0) {
                    window.tim.on(window.TIM.EVENT.SDK_READY, ()=>{
                      dispatch(AjaxAction.imGroupList(data.userid));
                    });

                    window.tim.on(window.TIM.EVENT.MESSAGE_RECEIVED, (e)=>{
                      this.onMsgNotify(e.data);
                    });

                    window.tim.on(window.TIM.EVENT.KICKED_OUT, (e)=>{
                      this.setState({
                        isKickOut:true
                      });
                    });

                    window.tim.on(window.TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED, this.onGroupSystemNoticeReceived);
                  }
                }).catch(e=>{
                  console.log('error', e);
                })
                //
                // window.webim.login({
                //     accountType:36862,
                //     identifier:data.userid,
                //     identifierNick:window.sessionStorage.getItem('nickname'),
                //     userSig:data.sign,
                //     sdkAppID:data.appid,
                // }, {
                //     "onConnNotify": this.onConnNotify,//监听连接状态回调变化事件,必填
                //     "onMsgNotify": this.onMsgNotify,//监听新消息(私聊，普通群(非直播聊天室)消息，全员推送消息)事件，必填
                //     // "onBigGroupMsgNotify": onBigGroupMsgNotify,//监听新消息(直播聊天室)事件，直播场景下必填
                //     "onGroupSystemNotifys": (resp)=>{
                //       console.log('system notify', resp);
                //     },//监听（多终端同步）群系统消息事件，如果不需要监听，可不填
                //     // "onGroupInfoChangeNotify": onGroupInfoChangeNotify,//监听群资料变化事件，选填
                //     // "onFriendSystemNotifys": onFriendSystemNotifys,//监听好友系统通知事件，选填
                //     // "onProfileSystemNotifys": onProfileSystemNotifys,//监听资料系统（自己或好友）通知事件，选填
                //     // "onKickedEventCall" : onKickedEventCall,//被其他登录实例踢下线
                //     "onC2cEventNotifys": (resp)=>{
                //       console.log('c2c notity', resp);
                //     },//监听 C2C 系统消息通道
                // }, {
                //     isAccessFormalEnv:true,
                //     isLogOn:false
                // },function(info) {
                //     console.log('login ok', info);
                //     dispatch(AjaxAction.imGroupList(data.userid));
                // },function(err) {
                //     console.log('login error', err);
                // });
            });
        }
    }

    getClockCount = (groupid)=>{
        if(groupid) {
            return this.state.unread[groupid] ? this.state.unread[groupid].length : 0;
        }else {
            var count = 0;
            Object.keys(this.state.unread).forEach(key=>{
                count += this.state.unread[key].length;
            });
            return count;
        }
    }

    renderHeader() {
        return <Row type="flex" align="middle" justify="space-between" style={{fontSize:'12px'}}>
            <div style={{display:'flex'}}>待办通知 {this.state.isKickOut ? <div className="im-warning">
              当前界面已失去连接，无法接收新的待办消息，请刷新界面后重新登录
            </div> : null}</div>
            <div><a onClick={this.onClose}><Icon type="close" /></a></div>
        </Row>;
    }

    onClose = ()=>{
        let {dispatch} = this.props;
        dispatch(actions.showIMDetail(false));
    }

    getOrderIdByGroupId = (groupid)=>{
      let split = (groupid || "").split('_');
      if(split && split.length == 2) {
        return split[1];
      }

      return '';
    }

    getCurrentGroupList = ()=>{
        let {dispatch} = this.props;
        let {currentGroup, groupStatus, unread} = this.state;
        let status = groupStatus[currentGroup.groupID] || {};
        let orderid = this.getOrderIdByGroupId(currentGroup.groupID);

        if(!status.isCompleted && orderid) {
          dispatch(AjaxAction.imGroupMessage(currentGroup.groupID, status.nextReqMessageID)).then(res=>{
            let {isCompleted, nextReqMessageID, data} = res;
            // 这里需要去加载一下所有历史未处理的
            dispatch(AjaxAction.imageMessageList({
              pageSize:100,
              key:JSON.stringify({
                orderid:orderid,
                status:0
              })
            })).then(res=>{
              if(res && res.data) {
                // 先过滤一遍ids吧
                let origins = (res.data || []).map(it=>{
                  if(it.type == 'delete') {
                    return it.name;
                  }
                  return null;
                }).filter(Boolean);

                dispatch(AjaxAction.imageList({
                  key:JSON.stringify({
                    origin:origins
                  })
                })).then(images=>{
                  images = images.data;

                  let history = (res.data || []).map(it=>{
                    let exist = data.find(msg=>msg.sequence == it.seqid);
                    if(exist) {
                      return null;
                    }else {
                      let payload = {
                        type:it.type
                      };
                      if(it.type == 'delete') {
                        let image = images.find(img=>img.origin == it.name);
                        if(image) {
                          payload.url = image.hash;
                          payload.imageid = image.id;
                          payload.messageid = it.id;
                          payload.galleryid = image.galleryid;
                        }else {
                          return null;
                        }
                      }
                      if(it.type == 'select') {
                        payload.imagename = it.name;
                        payload.messageid = it.id;
                      }

                      return {
                        seq:it.seqid,
                        uniqueId:it.id,
                        from:'jfoto_im_admin',
                        time:Math.round(moment(it.createtime).valueOf() / 1000),
                        type:'TIMCustomElem',
                        payload:{
                          data:JSON.stringify(payload)
                        }
                      }
                    }
                  }).filter(Boolean);
                  this.formatMessage(history.concat(data));

                  // 设置group的一些消息内容
                  status = {
                    isCompleted,
                    nextReqMessageID
                  };

                  // 清理未读消息
                  unread[currentGroup.groupID] = [];

                  groupStatus = {
                    ...groupStatus,
                    [currentGroup.groupID]:status
                  };
                  this.setState({
                    groupStatus,
                    unread
                  });
                });
              }
            })
          });
        }
    }

    selectGroup(group) {
        let {currentGroup, unred, messages} = this.state;
        console.log(currentGroup);
        this.setState({
            currentGroup:group
        }, ()=>{
            if(messages[group.groupID] && messages[group.groupID].length) {
                this.getCurrentGroupNewList();
            }else {
                this.getCurrentGroupList();
            }
        });
    }

    getCurrentGroupNewList = ()=>{
        let {dispatch} = this.props;
        let {currentGroup, messages, unread} = this.state;

        if(currentGroup && currentGroup.groupID) {
            var newMsg = unread[currentGroup.groupID] ? unread[currentGroup.groupID].slice() : [];
            unread[currentGroup.groupID] = [];

            newMsg.forEach(it=>{
                messages[currentGroup.groupID].unshift(it);
            });

            // 排序
            messages[currentGroup.groupID].sort(function(prep, next) {
                return next.seq * 1 - prep.seq * 1;
            });

            this.setState({
                messages,
                unread
            });
        }
    }

    formatItem = (it)=>{
        let result = [];
        // let {elems = []} = it;
        var message = {
            seq:it.seq,
            unique:it.uniqueId,
            userid:it.from,
            nickname: it.from == 'jfoto_im_admin' ? '小享' : it.from,
            createdAt:it.time * 1000,
        };

        let ele = it;

        if(ele.type == "TIMCustomElem") {
            try {
                var json = JSON.parse(ele.payload.data);
                if(json && json.type != 'recall') {
                  let copy = Object.assign({
                      type:json.type,
                      content:json.type == 'delete' ? '您有一张照片待删除，请尽快操作' : '您有一张照片待补选，请尽快操作',
                      extra:json.type == 'delete' ? {
                          url:json.url,
                          imageid:json.imageid,
                          messageid:json.messageid,
                          galleryid:json.galleryid
                      } : {
                          imagename:json.imagename,
                          messageid:json.messageid
                      }
                  }, message);

                  result.push(copy);
                }
            }catch(e) {}
        }
        if(ele.type == "TIMTextElem") {
            let copy = Object.assign({
                content:ele.payload.text,
                type:'text'
            }, message);

            result.push(copy);
        }

        return result;
    }

    formatMessage = (list, groupid)=>{
        let {messages, currentGroup} = this.state;

        if(currentGroup && currentGroup.groupID) {
            if(!messages[currentGroup.groupID]) {
                messages[currentGroup.groupID] = [];
            }
        }
        if(groupid) {
            if(!messages[groupid]) {
                messages[groupid] = [];
            }
        }

        list.forEach(it=>{
            var copys = this.formatItem(it);
            copys.forEach(c=>{
                messages[groupid ? groupid : currentGroup.groupID].unshift(c);
            });
        });

        // 排序
        if(messages[currentGroup.groupID]) {
          messages[currentGroup.groupID].sort(function(prep, next) {
              return next.seq * 1 - prep.seq * 1;
          });
        }

        this.setState({
            messages
        });
    }

    deleteImage = (item)=>{
        let {dispatch, myInfo} = this.props;
        let {extra} = item;
        if(extra && extra.imageid) {
            dispatch(AjaxAction.imageRemove(extra.imageid));
            dispatch(AjaxAction.imageMessageEdit(extra.messageid, {
                status:1,
                opertime:moment().format('YYYY-MM-DD HH:mm:ss'),
                operby:myInfo.id
            })).then(res=>{
                message.success('删除成功');
                dispatch(AjaxAction.imWithdraw(this.state.currentGroup.groupID, item.seq));

                this.markDone(this.state.currentGroup.groupID, item.seq);
            });
        };
    }

    selectDone = (item)=>{
        let {dispatch, myInfo} = this.props;
        let {extra} = item;
        if(extra && extra.messageid) {
            dispatch(AjaxAction.imageMessageEdit(extra.messageid, {
                status:1,
                opertime:moment().format('YYYY-MM-DD HH:mm:ss'),
                operby:myInfo.id
            })).then(res=>{
                message.success('处理成功');
                dispatch(AjaxAction.imWithdraw(this.state.currentGroup.groupID, item.seq));

                this.markDone(this.state.currentGroup.groupID, item.seq);
            });
        };
    }

    markDone = (groupid, seq)=>{
        let {messages} = this.state;

        if(messages[groupid]) {
            messages[groupid] = messages[groupid].map(it=>{
                if(it && it.seq == seq) {
                    it.done = true;
                };
                return it;
            });

            this.setState({
                messages
            });
        }
    }

    _renderdelete = (item)=>{
        const author = item.nickname;
        const avatar = <UserPhoto nickname={item.nickname} photo={item.photo} />;
        const datetime = moment(item.createdAt).fromNow();
        let {extra} = item;

        const content = <div className="message-list-item-row">
            <p>{item.content}</p>
            <div className="message-list-item-row-extra">
                <a href={'//image1.jfoto.cn/' + extra.url} target="_blank"><img src={'//image1.jfoto.cn/' + extra.url + '!avatar_150'} alt='' /></a>
            </div>
            <div className="message-list-item-row-action">
                <a onClick={()=>{
                    window.open(realGalleryPath(extra.galleryid), extra.galleryid);
                }}>跳转至相册</a>
                <Popconfirm title="请再次确认是否删除此照片？" onConfirm={()=>this.deleteImage(item)} okText="确认" cancelText="取消">
                    <a>删除此照片</a>
                </Popconfirm>
            </div>
        </div>;

        return <Comment
            author={author}
            avatar={avatar}
            content={content}
            datetime={datetime}
        />
    }

    _renderselect = (item)=>{
        const author = item.nickname;
        const avatar = <UserPhoto nickname={item.nickname} photo={item.photo} />;
        const datetime = moment(item.createdAt).fromNow();
        let {extra} = item;
        let {currentGroup} = this.state;

        const content = <div className="message-list-item-row">
            <p>{item.content}</p>
            <div className="message-list-item-row-extra">
                <p className="extra-link">
                    <span>{extra.imagename}</span>
                    <CopyToClipboard text={extra.imagename} onCopy={(text, result)=>{
                        result ? message.success('复制成功') : message.warn('复制失败');
                    }}><Icon type='copy' /></CopyToClipboard>
                </p>
            </div>
            <div className="message-list-item-row-action">
                <a onClick={()=>{
                    window.open('/page/gallery/fromorder/' + currentGroup.groupID.split('_')[1] + '/v2');
                }}>跳转至相册</a>
                {item.done ? null : <a onClick={()=>this.selectDone(item)}>已补选完成</a>}
            </div>
        </div>;

        return <Comment
            author={author}
            avatar={avatar}
            content={content}
            datetime={datetime}
        />
    }

    _renderrecall = (item)=>{
      return <div/>;
    }

    _rendertext = (item)=>{
        const author = item.nickname;
        const avatar = <UserPhoto nickname={item.nickname} photo={item.photo} />;
        const datetime = moment(item.createdAt).fromNow();

        const content = <div className="message-list-item-row">
            <p>{item.content}</p>
        </div>;

        return <Comment
            author={author}
            avatar={avatar}
            content={content}
            datetime={datetime}
        />
    }

    renderMessageItem = (item)=>{
        if(item.done) {
            return <div />;
        }
        return this['_render' + item.type](item);
    }

    render() {
        let {show, imGroupList} = this.props;
        let {search, unread} = this.state;

        let groupList = [].concat(imGroupList).filter(it=>{
          if(search) {
            if(it.name.indexOf(search) > -1) {
              return true;
            }
            return false;
          }
          return true;
        });
        groupList.sort(function(item, next) {
          if(item.lastMessageTime == next.lastMessageTime) {
            return 0;
          }
          if(item.lastMessageTime < next.lastMessageTime) {
            return 1;
          }
          if(item.lastMessageTime > next.lastMessageTime) {
            return -1;
          }
            // const aisBefore = moment().isBefore(item.actionstarttime * 1);
            // const aisAfter = moment().isAfter(item.actionendtime * 1);
            // const astatus = aisBefore ? 'wait' : (aisAfter ? 'end' : 'living');
            //
            // const bisBefore = moment().isBefore(next.actionstarttime * 1);
            // const bisAfter = moment().isAfter(next.actionendtime * 1);
            // const bstatus = bisBefore ? 'wait' : (bisAfter ? 'end' : 'living');
            // if(astatus == bstatus && astatus == 'living') {
            //     return 0;
            // }
            // if(astatus == 'living') {
            //     return -1;
            // }
            // if(bstatus == 'living') {
            //     return 1;
            // }

            return 0;
        });

        return <Right header={this.renderHeader()} selfControl={true} show={show} onClose={this.onClose}>
            <div className="im-content">
                <div className="group-list">
                    <div className="group-list-search">
                      <Input.Search placeholder="输入活动名称搜索" onSearch={(e)=>{
                        this.setState({
                          search:e
                        });
                      }} />
                    </div>
                    <List className="group-list-antd"
                        itemLayout="horizontal"
                        dataSource={groupList instanceof Array ? groupList.slice(0, 50) : []}
                        renderItem={item=>{
                            const isBefore = moment().isBefore(item.actionstarttime * 1);
                            const isAfter = moment().isAfter(item.actionendtime * 1);
                            const status = isBefore ? 'wait' : (isAfter ? 'end' : 'living');
                            const color = ({
                                'wait':'#999',
                                'end':'#0077d9',
                                'living':'#ff7700'
                            })[status];

                            const desc = (item.desc || '--') + ' ' + ({
                                'wait':'敬请期待',
                                'end':'精彩回顾',
                                'living':'正在直播'
                            })[status];

                            return <List.Item onClick={this.selectGroup.bind(this, item)} className={item.groupID + ' ' + (this.state.currentGroup && this.state.currentGroup.groupID == item.groupID ? 'active' : '')}>
                                <List.Item.Meta
                                    avatar={<Badge count={this.getClockCount(item.groupID)}>
                                        <Avatar shape="square" style={{ backgroundColor: color || '#999', verticalAlign: 'middle' }} size="large">{(item.name||"").substring(0,3)}</Avatar>
                                    </Badge>}
                                    title={item.name}
                                    description={desc}
                                />
                            </List.Item>
                        }}
                    />
                </div>
                <div className="message-list">
                    {this.state.currentGroup && this.state.currentGroup.groupID ? <React.Fragment>
                        {this.state.unread[this.state.currentGroup.groupID] && this.state.unread[this.state.currentGroup.groupID].length ?
                            <div onClick={this.getCurrentGroupNewList} className="message-list-newmsg">您有{this.state.unread[this.state.currentGroup.groupID].length}条新的消息，请点击查看</div>
                        : null}
                        <List className="message-list-antd"
                            itemLayout="horizontal"
                            dataSource={
                                this.state.messages[this.state.currentGroup.groupID] ? this.state.messages[this.state.currentGroup.groupID] : []
                                /*[{type:'delete', userid:'jfoto_im_admin', nickname:'小享', content:'你有一张图片待删除，请尽快操作', extra:'{"imageid":123456, "url":"source/00002bff2a1a9438925933be128fbd2e.jpg"}'},
                                {type:'select', userid:'jfoto_im_admin', nickname:'小享', content:'你有一张图片待补选，请尽快操作', extra:'{"imagename":"JFOTO_NV1099_201344222.jpg"}'},]*/
                            }
                            renderItem={this.renderMessageItem}
                        />
                    </React.Fragment> : null}
                </div>
                {this.state.isKickOut ? <div className="im-warning-mask">
                  当前界面已失去连接，请尝试刷新界面
                </div> : null}
            </div>
        </Right>;
    }
}

export default connect(state => ({
    im:state.im,
    imGroupList:state.imGroupList,
    myInfo: state.myInfo,
    show:state.ui.showIMDetail
}))(Index);



// WEBPACK FOOTER //
// ./src/components/IM/index.js